var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPlay6 = function SvgIconPlay6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69 69"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B328C",
    d: "m36.508 38.768-7.531 4.268V25.965l7.531 4.268 7.531 4.267-7.531 4.268zM34.5 0C15.446 0 0 15.447 0 34.5 0 53.554 15.446 69 34.5 69 53.553 69 69 53.554 69 34.5 69 15.447 53.553 0 34.5 0z"
  })));
};
export default SvgIconPlay6;